// SPDX-License-Identifier: AGPL-3.0-or-later

// Fork: the name the fork's apps go by until an instance says what it is called.
export const PRODUCT_NAME = 'Tyne';
export const DEFAULT_PREMIUM_PRODUCT_NAME = 'Plutonium';
